module.exports = __webpack_public_path__ + "static/img/company-ethics-hero-lores.926a5b0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/company-performance/company-ethics-hero-lores.jpg
// module id = JUft
// module chunks = 0